// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { quickOrderSearchStyles } from "@conklin/Overrides/Widgets/QuickOrder/QuickOrderSearch";
import { xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

quickOrderSearchStyles.productSelector = {
    container: { gap: 20 },
    searchGridItem: {
        width: [12, 12, 12, 5, 5],
        css: css`
            position: relative;
        `,
    },
    qtyGridItem: {
        width: [2, 3, 3, 2, 2],
        css: css`
            &&& {
                ${xScreen("lte", "md")} {
                    padding-top: 10px;
                }
            }
        `,
    },
    unitOfMeasureGridItem: {
        width: [4, 4, 4, 2, 2],
        css: css`
            ${xScreen("lte", "md")} {
                padding-top: 10px;
            }
        `,
    },
    buttonGridItem: {
        width: [4, 4, 4, 2, 2],
        css: css`
            justify-content: flex-start;
            align-items: flex-start;
            ${xScreen("lte", "md")} {
                padding-top: 10px;
            }
        `,
    },
    selectButton: {
        css: css`
            &&& {
                margin-top: 0;
                margin-bottom: 0;
            }
            ${xScreen("lte", "xs")} {
                &&& {
                    width: 100%;
                }
            }
        `,
    },
    uploadOrderGridItem: {
        width: [12, 5, 5, 12, 12],
        css: css`
            ${xScreen("lte", "md")} {
                justify-content: flex-end;
            }
            ${xScreen("lte", "sm")} {
                justify-content: flex-start;
            }
        `,
    },
};
